@if (d) {
    <qp-table-data
        [nullValues]=false
        [data]="
            [
                { k: 'Rsrq', v: d ? d + ' dB' : '', c: class_ }
            ]
        "

        (selected)="select($event)"
    >
    </qp-table-data>
    <!-- <mat-icon class="tab-icon">{{ Icons.link }}</mat-icon> -->
}